import CrowdfundingInvestment from './CrowdfundingInvestment';
export default CrowdfundingInvestment;
